import PropTypes from 'prop-types';

const root = 'https://res.cloudinary.com/zenbusiness';
const version = 'v1';
const project = 'shared-assets';

export const generateUrl = (src, width, height, quality, format, useFullUrl) => {
  if (useFullUrl) {
    return src;
  }

  const transforms = [`q_${quality}`];

  // for lottie animations
  if (src.includes('lottie')) {
    if (src.includes('/s2/')) {
      return `${root}/raw/upload/${project}${src}`;
    }
    return `${root}/raw/upload/${project}/animation${src}`;
  }
  // auto-format not supported for svg
  if (format && !src.endsWith('.svg')) {
    transforms.push(`f_${format}`);
  }

  if (height) {
    transforms.push(`h_${height}`);
  }

  if (width) {
    transforms.push(`w_${width}`);
  }

  return `${root}/${transforms.join(',')}/${version}/${project}${src}`;
};

const SharedAsset = ({
  src,
  width,
  height,
  quality,
  format,
  alt,
  className,
  useFullUrl
}) => {
  const url = generateUrl(src, width, height, quality, format, useFullUrl);
  return (
    <img src={url} alt={alt} className={className} />
  );
};

SharedAsset.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  quality: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['auto', 'auto:good', 'auto:best', 'auto:eco', 'auto:low'])
  ]),
  format: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  useFullUrl: PropTypes.bool
};

SharedAsset.defaultProps = {
  width: null,
  height: null,
  quality: 'auto',
  format: 'auto',
  alt: '',
  className: null,
  useFullUrl: false
};

export default SharedAsset;
